import { BasePage } from '@/components/ui/base-page'

export function FlotaPage() {
  return (
    <BasePage
      title="undefined"
      description="undefined"
    >
      {/* Add FlotaPage specific content here */}
    </BasePage>
  )
}